import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  align-items: center;
  overflow-x: hidden;
`;

export const BlurEffects = styled.div<{blur:boolean}>`
${props => props.blur === false && css`
  filter: blur(8px);
`};
height: 20%;
`;
